import React from 'react'
import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
// import * as StoreActions from 'x/modules/store/StoreState'
import XContainer from 'xui/components/XContainer'
import XCustomHeader from 'xui/components/XCustomHeader'
import XContent from 'xui/components/XContent'
import HStack from 'xui/components/HStack'
import { getSelectedStore, getEditingStore } from 'x/redux/selectors'
import {
  IApiOptions,
  ISelectedStoreMap,
  IErpAutoCreateShippingReceiptViewNavParams,
  IXScreenProps,
  IERPChannel,
  IMKPChannelDetail,
  IErpContact,
} from 'x/types'
import * as util from 'x/utils/util'
import api from 'x/utils/api'
import p from 'x/config/platform-specific'
import CONS from 'x/config/constants'
import * as NavActions from 'x/utils/navigation'

import XText from 'xui/components/XText'
import VStack from 'xui/components/VStack'
import XSwitch from 'xui/components/XSwitch'
import XSpinner from 'xui/components/XSpinner'
import _ from 'lodash'
import XRadioList from 'xui/components/XRadioList'
import MkpLogo from 'xui/components/MkpLogo'
import XCard from 'xui/components/XCard'
import XSellyLogo from 'xui/components/XSellyLogo'
import time from 'x/utils/time'
import XSegment from 'xui/components/XSegment'
import dayjs from 'dayjs'
import XDateTimeSinglePicker from 'xui/components/XDateTimeSinglePicker'

// example date format 2012-12-21T22:21:21+01:00
const DATE_REQ_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ'

const AUTO_CREATE_RECEIPT_PAYMENT_DATE = {
  ERP_CREATE_DATE: 'ERP_CREATE_DATE',
  XSELLY_CREATE_DATE: 'XSELLY_CREATE_DATE',
}

const AUTO_CREATE_RECEIPT_PAYMENT_DATE_OPTIONS = [
  {
    label: 'วันที่สร้างเอกสารไปที่ PEAK ',
    value: AUTO_CREATE_RECEIPT_PAYMENT_DATE.ERP_CREATE_DATE,
  },
  {
    label: 'วันที่สร้างออเดอร์ใน XSelly',
    value: AUTO_CREATE_RECEIPT_PAYMENT_DATE.XSELLY_CREATE_DATE,
  },
]

const ORDER_STATUS = {
  DISABLED: 'DISABLED',
  CONFIRMED: 'CONFIRMED',
  PAID: 'PAID',
  SHIPPED: 'SHIPPED',
}

const ORDER_STATUS_OPTIONS = [
  // {
  //   label: 'ปิดใช้งาน',
  //   value: 'DISABLED',
  // },
  {
    label: 'ยืนยันออเดอร์ ยืนยันรับชำระ หรือบันทึกจัดส่ง แล้ว',
    value: ORDER_STATUS.CONFIRMED,
  },
  {
    // (ร้านได้รับชำระจากแพลตฟอร์ม)
    label: 'ยืนยันรับชำระแล้ว หรือบันทึกจัดส่ง แล้ว',
    value: ORDER_STATUS.PAID,
  },
  {
    label: 'บันทึกจัดส่งแล้ว',
    value: ORDER_STATUS.SHIPPED,
  },
]

const BILLING_ADDRESS = {
  WITHOUT_BILLING_ADDRESS: 'WITHOUT_BILLING_ADDRESS',
  WITH_BILLING_ADDRESS: 'WITH_BILLING_ADDRESS',
  ALL: 'ALL',
}

const BILLING_ADDRESS_OPTIONS = [
  {
    label: 'ไม่มี ที่อยู่ผู้รับสำหรับใบกำกับภาษี',
    value: BILLING_ADDRESS.WITHOUT_BILLING_ADDRESS,
  },
  {
    label: 'มี ที่อยู่ผู้รับสำหรับใบกำกับภาษี',
    value: BILLING_ADDRESS.WITH_BILLING_ADDRESS,
  },
  {
    label: 'ทั้งหมด',
    value: BILLING_ADDRESS.ALL,
  },
]

export interface IErpAutoCreateShippingReceiptViewProps extends IXScreenProps<IErpAutoCreateShippingReceiptViewNavParams> {
  selectedStore: ISelectedStoreMap
}

export interface IErpAutoCreateShippingReceiptViewState {
  isInitialized: boolean
  isSubmitting: boolean

  isSubmittingAutoCreateReceipt: boolean
  isSubmittingAutoCreateReceiptWithTaxInvoice: boolean
  isSubmittingAutoCreateReceiptPaymentDate: boolean

  editingErpChannel: IERPChannel

  mkpChannels: IMKPChannelDetail[]
  erpMkpContacts: IErpContact[]
}
class ErpAutoCreateShippingReceiptView extends React.Component<
  IErpAutoCreateShippingReceiptViewProps,
  IErpAutoCreateShippingReceiptViewState
> {
  static displayName = 'ErpAutoCreateShippingReceiptView'

  inProcess?: boolean

  constructor(props) {
    super(props)

    this.state = {
      isInitialized: false,
      isSubmitting: false,

      editingErpChannel: null,

      mkpChannels: [],
      erpMkpContacts: [],

      isSubmittingAutoCreateReceipt: false,
      isSubmittingAutoCreateReceiptWithTaxInvoice: false,
      isSubmittingAutoCreateReceiptPaymentDate: false,
    }
  }

  async componentDidMount() {
    await this._initialize()
    // await this._onRefresh()
  }

  _initialize = async () => {
    const { selectedStore } = this.props
    const editingErpChannel = util.getNavParam(this.props, 'erpChannelDetail')

    const erpMkpContacts = await this._fetchErpMkpContacts()
    const mkpChannels = selectedStore.get('channels')?.toJS() || []
    // console.log('mkpChannels => ', mkpChannels)

    await util.setStatePromise(this, { isInitialized: true, editingErpChannel, mkpChannels, erpMkpContacts })
  }

  _goBack = () => {
    util.navGoBack(this.props)
  }

  _fetchErpMkpContacts = async (): Promise<IErpContact[]> => {
    const { selectedStore } = this.props
    const editingErpChannel = util.getNavParam(this.props, 'erpChannelDetail')

    const store_id = util.getNavParam(this.props, 'store_id', selectedStore.get('id'))
    const reqBody = {
      store_id,
      erp_ch_id: editingErpChannel.id,
    }

    const apiOptions: IApiOptions = {
      showSpinner: true,
    }

    try {
      const res: { erp_mkp_contacts: IErpContact[] } = await api.postV2('erp/contact/mkp/lists', reqBody, apiOptions)
      // console.log('_fetchErpMkpContacts res => ', res)

      return res.erp_mkp_contacts
      // await util.setStatePromise(this, { erpMkpContacts: res.erp_mkp_contacts })
    } catch (error) {
      console.log('error _fetchErpMkpContacts => ', error)
    }

    return []
  }

  _updateErpMkpContact = async (selectedContact: IErpContact, fieldName: string, newValue: any) => {
    const { selectedStore } = this.props
    const { editingErpChannel } = this.state
    const store_id = util.getNavParam(this.props, 'store_id', selectedStore.get('id'))

    const updateItem = {
      erp_sales_channel_setting_id: selectedContact.erp_sales_channel_setting_id,
    }
    updateItem[fieldName] = newValue

    const reqBody = {
      store_id,
      erp_ch_id: editingErpChannel.id,
      update: [updateItem],
    }

    const apiOptions: IApiOptions = {
      showSpinner: true,
    }

    try {
      const res: { erp_mkp_contacts: IErpContact[] } = await api.postV2('erp/setting/mkp/update', reqBody, apiOptions)
      // console.log('res => ', res)
      p.op.showToast('บันทึกข้อมูลเรียบร้อยแล้ว', 'success')
      return res.erp_mkp_contacts
    } catch (error) {
      console.log('error _updateContact => ', error)
      p.op.showToast('เกิดข้อผิดพลาดในการบันทึกข้อมูล', 'danger')
    }

    return null
  }

  _updateChannel = async (key: string, value: any): Promise<IERPChannel> => {
    const params = util.getNavParams(this.props)
    const { erp_ch_id } = params
    const { selectedStore } = this.props
    // const {} = this.state
    const store_id = selectedStore.get('id')
    const reqBody = {
      store_id,
      erp_ch_id,
      // [key]: value,
    }

    reqBody[key] = value

    const apiOptions: IApiOptions = {
      showSpinner: true,
    }

    try {
      const res = await api.postV2('erp/channel/update', reqBody, apiOptions)
      // console.log('res _fetchErpChannel => ', res)
      if (res.erp_channel_detail) {
        // await util.setStatePromise(this, {
        //   erpChannelDetail: res.erp_channel_detail,
        //   erpName: res.erp_channel_detail.name,
        // })

        const onSuccessEdit = util.getNavParam(this.props, 'onSuccessEdit')
        if (_.isFunction(onSuccessEdit)) {
          onSuccessEdit(res.erp_channel_detail)
        }

        // await this._setChannelDetail(res.erp_channel_detail)

        p.op.showToast('แก้ไขข้อมูลเรียบร้อยแล้ว', 'success')
        return res.erp_channel_detail
      }
    } catch (error) {
      console.log('error _updateChannel => ', error)
      p.op.showToast('เกิดข้อผิดพลาดในการแก้ไขข้อมูล', 'danger')
    }

    return null
  }

  _onChangeIsAutoCreateReceipt = async (value: boolean) => {
    if (this.inProcess) {
      return
    }
    this.inProcess = true
    await util.setStatePromise(this, { isSubmitting: true, isSubmittingAutoCreateReceipt: true })

    const newErpChannel = await this._updateChannel('auto_create_receipt_enable', value)
    const newState: Partial<IErpAutoCreateShippingReceiptViewState> = {
      isSubmitting: false,
      isSubmittingAutoCreateReceipt: false,
    }

    if (newErpChannel) {
      newState.editingErpChannel = newErpChannel
    }

    await util.setStatePromise(this, newState)
    this.inProcess = false
  }

  _renderAutoCreateReceipt = () => {
    const { editingErpChannel, isSubmitting, isSubmittingAutoCreateReceipt } = this.state

    if (_.isNil(editingErpChannel)) {
      return null
    }

    const isEnabled = 'auto_create_receipt_enable' in editingErpChannel ? editingErpChannel.auto_create_receipt_enable : false

    return (
      <VStack w='full' py='2' px='4' bg='white'>
        {/* <XText variant='active' bold>
          ตั้งค่า การสร้างใบเสร็จรับเงินอัตโนมัติ
        </XText> */}

        <HStack w='full' alignItems='center' space='1'>
          <HStack flex={1} alignItems='center'>
            <XText variant={isEnabled ? 'success' : 'inactive'} fontSize='md' bold>
              เปิดใช้งาน
            </XText>
          </HStack>

          <HStack w='80px' h='34px' justifyContent='flex-end' alignItems='center' space='1'>
            {isSubmittingAutoCreateReceipt ? <XSpinner size='sm' /> : null}
            <XSwitch disabled={isSubmitting} value={isEnabled} onValueChange={this._onChangeIsAutoCreateReceipt} />
          </HStack>
        </HStack>

        <XText variant='inactive'>เมื่อเปิดใช้งาน XSelly จะสร้างใบเสร็จรับเงินไปที่ PEAK ให้อัตโนมัติตามที่ตั้งค่าไว้</XText>
      </VStack>
    )
  }

  _onChangeIsAutoCreateReceiptWithTaxInvoice = async (value: boolean) => {
    if (this.inProcess) {
      return
    }
    this.inProcess = true
    await util.setStatePromise(this, { isSubmitting: true, isSubmittingAutoCreateReceiptWithTaxInvoice: true })

    const newErpChannel = await this._updateChannel('auto_create_receipt_with_tax_invoice', value)
    const newState: Partial<IErpAutoCreateShippingReceiptViewState> = {
      isSubmitting: false,
      isSubmittingAutoCreateReceiptWithTaxInvoice: false,
    }

    if (newErpChannel) {
      newState.editingErpChannel = newErpChannel
    }

    await util.setStatePromise(this, newState)
    this.inProcess = false
  }

  _renderAutoCreateReceiptWithTaxInvoice = () => {
    const { editingErpChannel, isSubmitting, isSubmittingAutoCreateReceiptWithTaxInvoice } = this.state

    if (_.isNil(editingErpChannel)) {
      return null
    }

    const isEnabled =
      'auto_create_receipt_with_tax_invoice' in editingErpChannel ? editingErpChannel.auto_create_receipt_with_tax_invoice : true

    return (
      <VStack w='full' borderTopWidth='1' borderTopColor='gray.300' py='2' px='4' bg='gray.100'>
        <HStack w='full' alignItems='center' space='1'>
          <HStack flex={1} alignItems='center'>
            <XText variant={'active'} bold>
              ออกควบใบกำกับภาษี
            </XText>
          </HStack>

          <HStack w='80px' h='34px' justifyContent='flex-end' alignItems='center' space='1'>
            {isSubmittingAutoCreateReceiptWithTaxInvoice ? <XSpinner size='sm' /> : null}
            <XSwitch disabled={isSubmitting} value={isEnabled} onValueChange={this._onChangeIsAutoCreateReceiptWithTaxInvoice} />
          </HStack>
        </HStack>

        <XText variant='inactive'>เมื่อเปิดใช้งาน เอกสารที่สร้างจะเป็น ใบเสร็จรับเงิน/ใบกำกับภาษี ในใบเดียวกัน</XText>
      </VStack>
    )
  }

  _onChangeAutoCreateReceiptPaymentDate = async (selectedOption, selectedIndex) => {
    if (this.inProcess) {
      return
    }
    this.inProcess = true
    await util.setStatePromise(this, { isSubmitting: true, isSubmittingAutoCreateReceiptPaymentDate: true })

    const newErpChannel = await this._updateChannel('auto_create_receipt_payment_date', selectedOption.value)
    const newState: Partial<IErpAutoCreateShippingReceiptViewState> = {
      isSubmitting: false,
      isSubmittingAutoCreateReceiptPaymentDate: false,
    }

    if (newErpChannel) {
      newState.editingErpChannel = newErpChannel
    }

    await util.setStatePromise(this, newState)
    this.inProcess = false
  }

  _renderAutoCreateReceiptPaymentDate = () => {
    const { editingErpChannel, isSubmitting, isSubmittingAutoCreateReceiptPaymentDate } = this.state

    if (_.isNil(editingErpChannel)) {
      return null
    }

    let selectedValue =
      'auto_create_receipt_payment_date' in editingErpChannel
        ? editingErpChannel.auto_create_receipt_payment_date
        : AUTO_CREATE_RECEIPT_PAYMENT_DATE.ERP_CREATE_DATE
    if (
      _.includes([AUTO_CREATE_RECEIPT_PAYMENT_DATE.ERP_CREATE_DATE, AUTO_CREATE_RECEIPT_PAYMENT_DATE.XSELLY_CREATE_DATE], selectedValue) ===
      false
    ) {
      selectedValue = AUTO_CREATE_RECEIPT_PAYMENT_DATE.ERP_CREATE_DATE
    }

    const selectedIndex = AUTO_CREATE_RECEIPT_PAYMENT_DATE_OPTIONS.findIndex((option) => option.value === selectedValue)

    return (
      <VStack w='full' borderTopWidth='1' borderTopColor='gray.300' py='2' px='4' bg='white'>
        <HStack w='full' alignItems='center' space='1'>
          <XText variant='active' bold>
            วันที่รับชำระ (หากยังไม่มีในออเดอร์)
          </XText>

          {isSubmittingAutoCreateReceiptPaymentDate ? <XSpinner size='sm' /> : null}
        </HStack>
        <XText variant='inactive'>
          เนื่องจากการสร้างใบเสร็จรับเงินไปที่ PEAK แต่ละออเดอร์จะต้องมีวันที่รับชำระ ดังนั้นหากในออเดอร์นั้นๆ
          ยังไม่มีการยืนยันบันทึกรับชำระ การสร้างใบเสร็จรับเงินจะใช้เป็นวันที่ตามที่เลือกด้านล่างนี้แทน เลือกวันที่ใช้เป็นวันที่รับชำระ
          (หากยังไม่มีในออเดอร์)
        </XText>

        <XRadioList
          disabled={isSubmitting}
          options={AUTO_CREATE_RECEIPT_PAYMENT_DATE_OPTIONS}
          selectedIndex={selectedIndex}
          onRadioChange={this._onChangeAutoCreateReceiptPaymentDate}
        />
      </VStack>
    )
  }

  _onChangeAutoCreateReceiptOrderNonCod = async (mkpContact, selectedValue) => {
    if (this.inProcess) {
      return
    }
    this.inProcess = true
    await util.setStatePromise(this, { isSubmitting: true })

    const updatedErpMkpContacts = await this._updateErpMkpContact(mkpContact, 'auto_create_receipt_order_non_cod', selectedValue)
    const newState: Partial<IErpAutoCreateShippingReceiptViewState> = { isSubmitting: false }

    if (updatedErpMkpContacts) {
      newState.erpMkpContacts = updatedErpMkpContacts
    }

    await util.setStatePromise(this, newState)
    this.inProcess = false
  }

  _onChangeAutoCreateReceiptOrderCod = async (mkpContact, selectedValue) => {
    if (this.inProcess) {
      return
    }
    this.inProcess = true
    await util.setStatePromise(this, { isSubmitting: true })

    const updatedErpMkpContacts = await this._updateErpMkpContact(mkpContact, 'auto_create_receipt_order_cod', selectedValue)
    const newState: Partial<IErpAutoCreateShippingReceiptViewState> = { isSubmitting: false }

    if (updatedErpMkpContacts) {
      newState.erpMkpContacts = updatedErpMkpContacts
    }

    await util.setStatePromise(this, newState)
    this.inProcess = false
  }

  _onChangeAutoCreateReceiptOrderBillingAddress = async (mkpContact, selectedValue) => {
    if (this.inProcess) {
      return
    }
    this.inProcess = true
    await util.setStatePromise(this, { isSubmitting: true })

    const updatedErpMkpContacts = await this._updateErpMkpContact(mkpContact, 'auto_create_receipt_order_billing_address', selectedValue)
    const newState: Partial<IErpAutoCreateShippingReceiptViewState> = { isSubmitting: false }

    if (updatedErpMkpContacts) {
      newState.erpMkpContacts = updatedErpMkpContacts
    }

    await util.setStatePromise(this, newState)
    this.inProcess = false
  }

  _onChangeAutoCreateReceiptSkipCreatedBefore = async (mkpContact, selectedDate: string | null) => {
    if (this.inProcess) {
      return
    }
    this.inProcess = true
    await util.setStatePromise(this, { isSubmitting: true })

    const updatedErpMkpContacts = await this._updateErpMkpContact(mkpContact, 'auto_create_receipt_skip_created_before', selectedDate)
    const newState: Partial<IErpAutoCreateShippingReceiptViewState> = { isSubmitting: false }

    if (updatedErpMkpContacts) {
      newState.erpMkpContacts = updatedErpMkpContacts
    }

    await util.setStatePromise(this, newState)
    this.inProcess = false
  }

  _renderErpMkpContacts = () => {
    // const { mkpChannels, editingErpChannel } = this.state
    const { erpMkpContacts, mkpChannels, editingErpChannel, isSubmitting } = this.state

    if (_.isNil(editingErpChannel)) {
      return null
    }

    // const selectedMkpChannelIds: number[] = editingErpChannel.auto_create_receipt_mkp_channels || []
    return (
      <VStack w='full' py='2' px='4' bg='gray.100' space='3'>
        <HStack w='full' alignItems='center'>
          <XText variant='active' bold>
            การสร้างใบเสร็จรับเงินอัตโนมัติ สำหรับแต่ละช่องทางขาย
          </XText>
        </HStack>

        <VStack w='full' space='2'>
          {erpMkpContacts.map((mkpContact, index: number) => {
            // const isSelected = selectedMkpChannelIds.includes(mkpChannel.id)
            const mkpChannel = mkpChannels.find((mkp) => mkp.id === mkpContact.sales_channel_id)
            // const erpcontactName = mkpChannel ? mkpChannel.name : '-'
            // const contactName = mkpContact.contact_name ? mkpContact.contact_name : ''
            // const contactCode = mkpContact.contact_code ? mkpContact.contact_code : ''

            // let LOGO_RENDER = null
            // if (contact.sales_channel_type === 'XSELLY') {
            //   erpcontactName = contact.sales_channel_type
            //   LOGO_RENDER = <XSellyLogo />
            // } else if (contact.sales_channel_type === 'MKP') {
            //   LOGO_RENDER = <MkpLogo mkpId={mkpChannel.mkp_id} />
            // }

            if (mkpContact.sales_channel_type === 'XSELLY') {
              return (
                <XCard key={`xselly-channel-${index}`}>
                  <VStack
                    w='full'
                    borderTopWidth='1'
                    borderTopColor='gray.300'
                    py='2'
                    px='4'
                    bg={index % 2 === 0 ? 'white' : 'gray.50'}
                    space='2'
                  >
                    <HStack flex={1} alignItems='center' space='2'>
                      <XSellyLogo width={24} height={24} />
                      <XText bold>XSELLY</XText>
                    </HStack>

                    {/* <VStack w='full' pl='6' space='2'> */}
                    <HStack w='full' alignItems='center' justifyContent='center' p='2' bg='warning.100' borderRadius='lg'>
                      <XText color='warning.700'>ยังไม่สามารถสร้างใบเสร็จรับเงินอัตโนมัติในช่องทาง XSELLY</XText>
                    </HStack>
                    {/* </VStack> */}
                  </VStack>
                </XCard>
              )
            }

            // const mkpSettings = this._getErpSalesChannelSettings(mkpChannel.id)
            const auto_create_receipt_order_non_cod = mkpContact?.auto_create_receipt_order_non_cod || ORDER_STATUS.DISABLED
            const auto_create_receipt_order_cod = mkpContact?.auto_create_receipt_order_cod || ORDER_STATUS.DISABLED
            const auto_create_receipt_order_billing_address =
              mkpContact?.auto_create_receipt_order_billing_address || BILLING_ADDRESS.WITHOUT_BILLING_ADDRESS

            const availableOrderStatuses = ORDER_STATUS_OPTIONS.map((opt) => opt.value)
            const isAutoCreateReceiptOrderNonCodEnabled = _.includes(availableOrderStatuses, auto_create_receipt_order_non_cod)
            const selectedAutoCreateReceiptOrderNonCodIndex = availableOrderStatuses.indexOf(auto_create_receipt_order_non_cod)

            const isAutoCreateReceiptOrderCodEnabled = _.includes(availableOrderStatuses, auto_create_receipt_order_cod)
            const selectedAutoCreateReceiptOrderCodIndex = availableOrderStatuses.indexOf(auto_create_receipt_order_cod)

            const availableBillingAddressOptions = BILLING_ADDRESS_OPTIONS.map((opt) => opt.value)
            const selectedAutoCreateReceiptOrderBillingAddressIndex = availableBillingAddressOptions.indexOf(
              auto_create_receipt_order_billing_address
            )

            // string of date
            const autoCreateReceiptSkipCreatedBefore = mkpContact?.auto_create_receipt_skip_created_before || null

            // const isAutoCreateReceiptOrderBillingAddressEnabled = _.isString(auto_create_receipt_order_billing_address)

            return (
              <XCard key={`mkp-channel-${mkpChannel.id}`}>
                <VStack
                  // key={`mkp-channel-${mkpChannel.id}`}
                  w='full'
                  borderTopWidth='1'
                  borderTopColor='gray.300'
                  py='2'
                  px='4'
                  bg={index % 2 === 0 ? 'white' : 'gray.50'}
                  space='2'
                >
                  <HStack flex={1} alignItems='center' space='2'>
                    <MkpLogo mkpId={mkpChannel.mkp_id} width={24} height={24} />
                    <XText bold>{mkpChannel.name}</XText>
                  </HStack>

                  <VStack w='full' pl='8' space='2'>
                    {/* <XText variant='active' flex={1}>
                      สร้างใบเสร็จรับเงินอัตโนมัติ
                    </XText> */}

                    <HStack w='full' alignItems='center'>
                      <XText variant='active' flex={1}>
                        ออเดอร์ที่ไม่เป็น COD
                      </XText>

                      <XSwitch
                        disabled={isSubmitting}
                        value={isAutoCreateReceiptOrderNonCodEnabled}
                        onValueChange={(newValue) => {
                          // console.log('isAutoCreateReceiptOrderNonCodEnabled newValue => ', newValue)
                          if (newValue) {
                            this._onChangeAutoCreateReceiptOrderNonCod(mkpContact, 'CONFIRMED')
                          } else {
                            this._onChangeAutoCreateReceiptOrderNonCod(mkpContact, 'DISABLED')
                          }
                          // Update API
                        }}
                      />
                    </HStack>

                    {isAutoCreateReceiptOrderNonCodEnabled ? (
                      <VStack w='full'>
                        <XText variant='inactive'>สร้างใบเสร็จรับเงินอัตโนมัติเมื่อสถานะออเดอร์ เป็น...</XText>

                        <XRadioList
                          disabled={isSubmitting}
                          options={ORDER_STATUS_OPTIONS}
                          selectedIndex={selectedAutoCreateReceiptOrderNonCodIndex}
                          onRadioChange={(opt) => {
                            this._onChangeAutoCreateReceiptOrderNonCod(mkpContact, opt.value)
                          }}
                        />
                      </VStack>
                    ) : null}

                    <HStack w='full' alignItems='center'>
                      <XText variant='active' flex={1}>
                        ออเดอร์ที่เป็น COD
                      </XText>

                      <XSwitch
                        disabled={isSubmitting}
                        value={isAutoCreateReceiptOrderCodEnabled}
                        onValueChange={async (newValue) => {
                          if (newValue) {
                            await this._onChangeAutoCreateReceiptOrderCod(mkpContact, 'CONFIRMED')
                          } else {
                            await this._onChangeAutoCreateReceiptOrderCod(mkpContact, 'DISABLED')
                          }
                        }}
                      />
                    </HStack>

                    {isAutoCreateReceiptOrderCodEnabled ? (
                      <VStack w='full'>
                        <XText variant='inactive'>สร้างใบเสร็จรับเงินอัตโนมัติเมื่อสถานะออเดอร์ เป็น...</XText>

                        <XRadioList
                          disabled={isSubmitting}
                          options={ORDER_STATUS_OPTIONS}
                          selectedIndex={selectedAutoCreateReceiptOrderCodIndex}
                          onRadioChange={(opt) => {
                            this._onChangeAutoCreateReceiptOrderCod(mkpContact, opt.value)
                          }}
                        />
                      </VStack>
                    ) : null}

                    {isAutoCreateReceiptOrderCodEnabled || isAutoCreateReceiptOrderNonCodEnabled ? (
                      <VStack w='full' pt='2' space='1'>
                        <XText>เงื่อนไขของออเดอร์สำหรับการสร้างใบเสร็จรับเงินอัตโนมัติ</XText>

                        <VStack w='full'>
                          <XText variant='inactive'>ที่อยู่ผู้รับสำหรับใบกำกับภาษี</XText>
                          <XRadioList
                            disabled={isSubmitting}
                            options={BILLING_ADDRESS_OPTIONS}
                            selectedIndex={selectedAutoCreateReceiptOrderBillingAddressIndex}
                            onRadioChange={(opt) => {
                              this._onChangeAutoCreateReceiptOrderBillingAddress(mkpContact, opt.value)
                            }}
                          />
                        </VStack>

                        <VStack w='full' space='1'>
                          <XText variant='inactive'>วันเวลาที่ถูกสร้างในช่องทางขาย</XText>

                          <VStack w='full' bg='white'>
                            <XSegment
                              disabled={isSubmitting}
                              options={[
                                { label: 'ทั้งหมด', value: 'ALL' },
                                { label: 'ตั้งแต่', value: 'TODAY_ONWARDS' },
                              ]}
                              selectedIndex={_.isString(autoCreateReceiptSkipCreatedBefore) ? 1 : 0}
                              onSegmentChange={(opt) => {
                                if (opt.value === 'TODAY_ONWARDS') {
                                  const nowTimeString = dayjs().format(DATE_REQ_FORMAT)
                                  this._onChangeAutoCreateReceiptSkipCreatedBefore(mkpContact, nowTimeString)
                                } else {
                                  this._onChangeAutoCreateReceiptSkipCreatedBefore(mkpContact, null)
                                }
                              }}
                            />
                          </VStack>

                          {_.isString(autoCreateReceiptSkipCreatedBefore) ? (
                            <HStack w='full' pt='1.5' alignItems='center' space='2'>
                              <XText variant='inactive'>ตั้งแต่: </XText>

                              <HStack flex={1}>
                                <XDateTimeSinglePicker
                                  key={autoCreateReceiptSkipCreatedBefore.toString()}
                                  disabled={isSubmitting}
                                  showTime
                                  selectedDate={dayjs(autoCreateReceiptSkipCreatedBefore).toDate()}
                                  onChangeDate={(newDate) => {
                                    const newDateObj = dayjs(newDate)
                                    if (!newDateObj.isValid()) {
                                      return
                                    }

                                    if (newDateObj.isSame(dayjs(autoCreateReceiptSkipCreatedBefore))) {
                                      return
                                    }

                                    const newDateString = dayjs(newDate).format(DATE_REQ_FORMAT)
                                    this._onChangeAutoCreateReceiptSkipCreatedBefore(mkpContact, newDateString)
                                  }}
                                />
                              </HStack>
                            </HStack>
                          ) : null}
                          {/* <XText>DEBUG: {autoCreateReceiptSkipCreatedBefore}</XText> */}
                        </VStack>
                      </VStack>
                    ) : null}
                  </VStack>
                </VStack>
              </XCard>
            )
          })}
        </VStack>
      </VStack>
    )
  }

  _renderHeaderRight = () => {
    const { isSubmitting } = this.state

    if (isSubmitting) {
      return (
        <HStack w='34px' h='34px' justifyContent='center' alignItems='center'>
          <XSpinner size='sm' />
        </HStack>
      )
    }

    return null
  }

  renderContent = () => {
    const { isInitialized, editingErpChannel } = this.state

    if (!isInitialized) {
      return <XSpinner size='lg' />
    }

    const isAutoCreateReceiptEnabled =
      'auto_create_receipt_enable' in editingErpChannel ? editingErpChannel.auto_create_receipt_enable : false

    return (
      <VStack w='full' py='3' bg='white'>
        {this._renderAutoCreateReceipt()}
        {isAutoCreateReceiptEnabled && this._renderAutoCreateReceiptWithTaxInvoice()}
        {isAutoCreateReceiptEnabled && this._renderAutoCreateReceiptPaymentDate()}
        {isAutoCreateReceiptEnabled && this._renderErpMkpContacts()}
      </VStack>
    )
  }

  render() {
    return (
      <XContainer>
        <XCustomHeader
          title='ตั้งค่า การสร้างใบเสร็จรับเงินอัตโนมัติ'
          headerLeftProps={{ backIcon: true, onPressItem: this._goBack }}
          headerRight={this._renderHeaderRight()}
        />
        <XContent>{this.renderContent()}</XContent>
      </XContainer>
    )
  }
}

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
    editingStore: getEditingStore(state),
    // subscription: getSubscription(state),

    // selectedStoreOrdersDates: getSelectedStoreOrdersDates(state),
    // selectedStoreOrdersDatesOptionKey: getSelectedStoreOrdersDatesOptionKey(state),
  }),
  (dispatch) => ({
    dispatch,
    // submitEditing: bindActionCreators(StoreActions.submitEditingStore, dispatch),
    // resetEditingStore: bindActionCreators(StoreActions.resetEditingStore, dispatch),
    // onChangeEditingStore: bindActionCreators(StoreActions.onChangeEditingStore, dispatch),
    // storeActions: bindActionCreators(StoreState, dispatch),
  })
)(ErpAutoCreateShippingReceiptView)
